
import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import _ from 'lodash';
import {getModule} from 'vuex-module-decorators';
import {AppModule, store, TradeInModule, CustomerModule, ShopModule} from "@returns-centre/store";

@Component
export default class TradeInAddress extends Vue {
    shopModule = getModule(ShopModule, store);
    tradeInModule = getModule(TradeInModule, store);
    customerModule = getModule(CustomerModule, store);
    appModule = getModule(AppModule, store);
    hasAddressUpdate: boolean = false;
    isNewCustomer: boolean = false;
    address: ShopifyAddress | null = {
        address1: '',
        address2: '',
        city: '',
        company: '',
        country: '',
        country_code: '',
        first_name: '',
        last_name: '',
        phone: '',
        province: '',
        province_code: '',
        zip: '',
        email: '',
        is_province_applicable: false
    }

    selectedCountry: Country | null = null
    selectedProvince: Province | null = null;
    isEmptyContactName: boolean | null = false;

    async mounted() {
        const storedCustomer = this.customerModule.returnsPortalShopifyCustomer

        await this.appModule.fetchCountries();
        if (!_.isEmpty(this.tradeInModule.tradeInAddress)) {
            this.address = _.clone(this.tradeInModule.tradeInAddress);
            if (this.address) {
                this.address!.is_province_applicable = false;
                if (this.address.country_code) {
                    this.selectedCountry = _.find(this.appModule.getCountries, [
                        'code', this.address.country_code
                    ]) || null;
                }

                this.address!.is_province_applicable = this.selectedCountry
                    ? this.selectedCountry.is_province_applicable : false;

                if(this.selectedCountry && this.address.province_code) {
                    this.selectedProvince = _.find(this.selectedCountry.province_list, [
                        'id', this.address.province_code
                    ])!;
                }
            }
        } else {
            this.isNewCustomer = true;
        }

        if (!_.isEmpty(storedCustomer) && !_.isEmpty(this.address)) {
            this.address.first_name = storedCustomer.first_name || '';
            this.address.last_name = storedCustomer.last_name || '';
            this.address.email = storedCustomer.email || '';
            this.address.phone = storedCustomer.address?.phone || '';
        }

        if (_.isEmpty(this.address)) {
            this.isEmptyContactName = true;
        } else if (this.address.first_name === '' || this.address.last_name === '') {
            this.isEmptyContactName = true;
        }

        if (!_.isEmpty(this.tradeInModule.tradeInAddress) && !_.isEmpty(this.address)) {
            this.address.first_name = this.tradeInModule.tradeInAddress.first_name || '';
            this.address.last_name = this.tradeInModule.tradeInAddress.last_name || '';
            this.address.email = this.tradeInModule.tradeInAddress.email || '';
            this.address.phone = this.tradeInModule.tradeInAddress.phone || '';
        }

        if (_.isNull(this.selectedCountry) && this.shopModule.shop) {
            this.selectDefaultMerchantCountry();
        }
    }

    onCountryChanged(id: number) {
        const country = _.find(this.appModule.getCountries, country => country.id == id);

        if (!country) {
            this.address!.country = '';
            this.address!.country_code = ''
            this.address!.province = '';
            this.address!.province_code = '';
            return;
        }

        this.address!.province_code = '';
        this.address!.country = country.name;
        this.address!.country_code = country.code;
        this.address!.is_province_applicable = country.is_province_applicable;

        if (!country.is_province_applicable) {
            this.address!.province = ''
            this.selectedProvince = null;
        }

        this.selectedCountry = country;
        this.clearError('address.country')
        this.clearError('address.province')
    }

    onProvinceChanged(id: string) {
        const province = _.find(this.selectedCountry!.province_list, province => province.id == id);
        if(!id || !province) { return; }
        this.address!.province = province.label;
        this.address!.province_code = province.id;
        this.clearError('address.province')
    }

    error(field: string) {
        if (this.tradeInModule.errors && this.tradeInModule.errors[field]) {
            return this.tradeInModule.errors[field][0];
        }

        return null;
    }

    clearError(field: string) {
        if (this.tradeInModule.errors && this.tradeInModule.errors[field]) {
            this.tradeInModule.context.commit('CLEAR_ERROR', field);
        }
    }

    selectDefaultMerchantCountry(): void {
        if (!this.shopModule || !this.shopModule.shop) {
            return;
        }

        const country = _.find(this.appModule.getCountries, [
            'code', this.shopModule.shop.return_label_country_code
        ]) ?? null;

        if (country) {
            this.address!.province_code = '';
            this.address!.country = country.name;
            this.address!.country_code = country.code;
            this.address!.is_province_applicable = country.is_province_applicable;

            if (!country.is_province_applicable) {
                this.address!.province = ''
                this.selectedProvince = null;
            }
        }

        this.selectedCountry = country;
    }

    @Watch('address', {deep: true})
    onAddressChanged(address: ShopifyAddress) {
        this.tradeInModule.setTradeInAddress(address);
    }
}
